import react from 'react';

class ErrorBoundary extends react.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
   // logErrorToMyService(error, errorInfo); report and log
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <div className="error-container">
        <div className="error-message">
          <img className="error-icon" src="./500.png" alt="Error 500" />
          <h2 className="text-color">Sorry...</h2>
          <h4 className="text-color mb-0">Something went wrong.</h4>
          <p className="text-color mb-0">Refresh the site. If the error persists, feel free to contact us.</p>
          <div className="error-buttons">
            <a className="btn btn-primary " href="/">Home</a>
            <a className="btn btn-outline-secondary " href="https://www.navmatix.com/contact/#form" target="_blank" rel="noopener noreferrer">Contact us</a>
          </div>
        </div>
      </div>
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;